<template>
    <v-container  v-resize="onResize">
        <v-layout row wrap pt-4 align-center>
            <v-flex xs12 md6>
                <h1>Shadow Ministries</h1>
            </v-flex>
            <v-flex xs12 offset-md2 md4>
                <v-text-field :class="{mobileTextField: isMobile}" v-if="!loading" v-on:keyup="TRACK_SEARCH" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                <v-menu v-if="!this.loading && this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                        <v-btn outline small slot="activator">
                            Sort <v-icon>sort</v-icon>
                        </v-btn>
                        <v-list>
                            <v-subheader>Sort by:</v-subheader>
                            <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                                <v-list-tile-title>
                                    {{ item.text }}
                                    <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
            </v-flex>
        </v-layout>

        <template>
            <v-card v-if="loading">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </template>
        <br>
        <div v-if="!loading" class="ministries-table">
            <v-data-table :headers="HEADERS" 
            :items="SHADOWMINISTRIES" 
            :rows-per-page-items="ROWS_LISTITEMS" 
            :pagination.sync="PAGINATION" 
            :hide-headers="isMobile"
            :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
            v-on:update:pagination="UPDATE_PAGINATION" 
            :search="search" class="elevation-1">
                <template v-slot:items="props">
                    <router-link v-if="isMobile" class="tr" :to="{ name: $store.state.ROUTE_SHADOWMINISTRY, params: { SMID: props.item.SMID, Name: props.item.Name , MinistryStart: props.item.DateStart, MinistryEnd: props.item.DateEnd }}">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item">
                                    <h3 class="pb-xs-1">{{ props.item.Name }}</h3>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-30">
                                    <div class="flex-item">
                                        <Portrait v-bind:PHID="props.item.LeaderPHID" :fixedWidth="80"></Portrait>
                                    </div>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-70">
                                    <div class="flex-item flex-item-col flex-item-col-40" data-label="Established">{{ props.item.DateStart | stringDateFormat }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-60" data-label="Ceased">
                                        <span v-if="props.item.DateEnd">{{ props.item.DateEnd | stringDateFormat }}</span>
                                        <span v-if="!props.item.DateEnd">N/A</span>
                                    </div>
                                    <div class="pt-3 flex-item flex-item-col flex-item-col-60" data-label="Shadow Ministers">{{ props.item.Ministers }}</div>
                                </div>
                                <div class="flex-item" data-label="Parties">
                                    <template v-for="party in props.item.Parties">
                                        <div>
                                            <v-chip disabled small light>
                                                <v-avatar :color="party.Colour != null ? party.Colour : '#919191'" >
                                                    <span :style="{'color': (party.Colour == null || party.Colour.toLowerCase() != '#bfff00' ? '#fff' : '#000') }">{{ party.Count }}</span>
                                                </v-avatar>
                                                {{ party.Name }}
                                            </v-chip>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </td>
                    </router-link>
                    <router-link v-else class="tr" :to="{ name: $store.state.ROUTE_SHADOWMINISTRY, params: { SMID: props.item.SMID, Name: props.item.Name , MinistryStart: props.item.DateStart, MinistryEnd: props.item.DateEnd }}">
                        <td class="text-xs-left">
                            {{ props.item.SMID }}
                            <Portrait v-bind:PHID="props.item.LeaderPHID" class="hidden-lg-and-up" :fixedWidth="80"></Portrait>
                        </td>
                        <td class="text-xs-left hidden-md-and-down">
                            <Portrait v-bind:PHID="props.item.LeaderPHID" :fixedWidth="80"></Portrait>
                        </td>
                        <td class="text-xs-left">{{ props.item.Name }}</td>
                        <td class="text-xs-left">{{ props.item.Ministers }}</td>
                        <td class="text-xs-left">
                            <!-- {{props.item.Parties.reduce((n, {Count}) => n + Count, 0)}} -->
                            <template v-for="party in props.item.Parties">
                                <div>
                                    <v-chip disabled small light>
                                        <v-avatar :color="party.Colour != null ? party.Colour : '#919191'" >
                                             <span :style="{'color': (party.Colour == null || party.Colour.toLowerCase() != '#bfff00' ? '#fff' : '#000') }">{{ party.Count }}</span>
                                        </v-avatar>
                                        {{ party.Name }}
                                    </v-chip>
                                </div>
                            </template>
                        </td>
                        <td class="text-xs-left">{{ props.item.DateStart | stringDateFormat }}</td>
                        <td class="text-xs-left">
                            <span v-if="props.item.DateEnd">{{ props.item.DateEnd | stringDateFormat }}</span>
                            <span v-if="!props.item.DateEnd">N/A</span>
                        </td>
                    </router-link>
                </template>

                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>
             <v-layout row wrap>
                <v-flex xs8>
                    <br />
                    <div>* This number is an aggregate of all Shadow Ministers who served during each Shadow Ministry.</div>
                    <div>† The party numbers are an aggregate of all party service during each Shadow Ministry,
                        <br /> and may exceed the total number of Shadow Ministers in the case where Shadow Ministers changed parties or a party was re-named.</div>
                </v-flex>
                <v-flex xs4>
                    <v-btn class="csvButton" color="primary" @click="EXPORTTOCSV()" v-on:keyup.enter="EXPORTTOCSV()" v-if="SHADOWMINISTRIES.length">
                        <v-icon aria-hidden="true" class="mr-1">text_snippet</v-icon>
                        <span>Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>

           
        </div>
        <br />
    </v-container>
</template>

<script>
    window.scrollTo(0, 0);
    import axios from 'axios'
    import Portrait from '@/components/Portrait.vue'
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri; 

    export default {
        data() {
            return {
                isMobile: false,
                loading: true,
                SHADOWMINISTRIES: [],
                SHADOWMINISTRIES_STATS: [],
                search: '',
                CSV_HEADERS: [{ label: 'ID', value: 'SMID' }, { label: 'Shadow Ministry', value: 'Name' }, { label: 'ShadowMinisters', value: 'Ministers' }, 'DateStart', 'DateEnd'],  //  " + this.$store.state.STRING_CRLF,
                CSV_FILENAME: "Handbook-Shadow Ministries",
                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],
                PAGINATION: {
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE,
                    sortBy: 'SMID',
                    descending: true
                },
                HEADERS: [{
                    text: 'Number',
                    value: 'SMID',
                    align: 'left',
                    sortable: true,
                    width: "60px",
                },
                {
                    text: '',
                    value: 'Name',
                     align: 'left hidden-md-and-down',
                    sortable: false,
                    width: "130px"
                },
                {
                    text: 'Shadow Ministry',
                    value: 'Name',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Total Shadow Ministers*',
                    value: 'Ministers',
                    sortable: true,
                    width: "125px",
                    align: 'left',
                },
                {
                    text: 'Parties†',
                    value: 'Parties',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: this.$store.state.STRING_ESTABLISHED,
                    value: 'DateStart',
                    align: 'left',
                    width: "120px",
                    sortable: true,
                    sort: (a, b) => this.$moment(a) > this.$moment(b)
                },
                {
                    text: this.$store.state.STRING_CEASED,
                    value: 'DateEnd',
                    align: 'left',
                    width: "120px",
                    sortable: true,
                    sort: (a, b) => this.$moment(a) > this.$moment(b)
                },
                ],
            }
        },
        created() {
            this.loadShadowMinistries();
        },
        mounted() {
            this.onResize();
            //Set page to 10 on mobile, only on mount
            if (this.isMobile){
                this.PAGINATION.rowsPerPage = 10;
            }
        },
        methods: {
            onResize() {
                if (window.innerWidth < 769){
                    this.isMobile = true;
                }
                else{
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                } 
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            loadShadowMinistries() {
                var ministriesLoading = true;
                var ministriesStatsLoading = true;

                this.loading = true;
                const url = "shadowministries?Select=MID,MIDOrdinal,Name,DateStart,DateEnd";
                axios.get(`api/${url}`)
                    .then(response => {
                        this.SHADOWMINISTRIES = response.data.value;

                        ministriesLoading = false;
                        if (!ministriesStatsLoading && !ministriesLoading){
                            this.loading = false;
                            this.addStatsToMinistries();
                        }
                    });

                const statsUrl = `StatisticalInformation/ShadowMinistries`;
                axios.get(`api/${statsUrl}`)
                .then(response => {
                    this.SHADOWMINISTRIES_STATS = response.data;

                    ministriesStatsLoading = false;
                    if (!ministriesStatsLoading && !ministriesLoading){
                        this.loading = false;
                        this.addStatsToMinistries();
                    }
                });
            },
            addStatsToMinistries(){
                this.SHADOWMINISTRIES = this.SHADOWMINISTRIES.map((record) => ({ ...record, 
                    Parties: this.SHADOWMINISTRIES_STATS.find(m => m.Id == record.SMID.toString()).Parties,
                    Ministers: this.SHADOWMINISTRIES_STATS.find(m => m.Id == record.SMID.toString()).Ministers,
                    LeaderPHID: this.SHADOWMINISTRIES_STATS.find(m => m.Id == record.SMID.toString()).LeaderPHID }))
            },
            EXPORTTOCSV() {
                this.$gtag.event('shadow ministries download csv', {
                    'event_category': 'downloads',
                    'event_label': 'shadow ministries search csv download',
                    'value': 1
                });
                const comment = `The Shadow Ministers column is an aggregate of all Shadow Ministers who served during each Shadow Ministry.`;
                this.$store.dispatch('GETCSV', { DATA: this.SHADOWMINISTRIES, HEADERS: this.CSV_HEADERS, FILENAME: this.CSV_FILENAME, STRICTHEADERS: true, COMMENT: comment })
            },

            UPDATE_PAGINATION: function (options) {
                this.$gtag.event('shadow ministries pagination items per page', {
                    'event_category': 'filters',
                    'event_label': `items per page: ${options.rowsPerPage}`,
                    'value': 1
                });
                this.$gtag.event('shadow ministries pagination page', {
                    'event_category': 'filters',
                    'event_label': `page: ${options.page}`,
                    'value': 1
                });
                this.$gtag.event('shadow ministries sorting', {
                    'event_category': 'sorting',
                    'event_label': `sort by ${options.sortBy} ${options.descending ? 'DESC' : 'ASC'}`,
                    'value': 1
                });
                return this.PAGINATION;
            },

            TRACK_SEARCH: function () {
                if (this.search.length >= 3) {
                    this.$gtag.event('filter shadow ministries - search', {
                        'event_category': 'filters',
                        'event_label': this.search,
                        'value': 1
                    });
                }
            }
        },
        components: {
            Portrait
        }
    }
</script>

<style lang="stylus" scoped>
    .v-progress-circular {
        margin: 1rem
    }

    a {
        color: #fff;
        text-decoration: underline;
    }

    .v-datatable .tr {
        display:table-row;
    }

    .v-datatable a.tr {
        color: #0e1531de;
        text-decoration:none;
        border: 1px solid #dbdbdb;
        border-left: none;
        border-right: none;
    }

    .v-datatable tbody td {
        vertical-align: middle;
    }

        .theme--light.v-chip {
        background: #dddddd;
        color: #000;
    }
    .theme--light.v-chip .v-avatar{
        color: #fff;
    }

     @media screen and (max-width: 1420px) {
        .ministries-table >>> table.v-table thead td:not(:nth-child(1)), 
        .ministries-table >>> table.v-table tbody td:not(:nth-child(1)), 
        .ministries-table >>> table.v-table thead th:not(:nth-child(1)), 
        .ministries-table >>> table.v-table tbody th:not(:nth-child(1)), 
        .ministries-table >>> table.v-table thead td:first-child, 
        .ministries-table >>> table.v-table tbody td:first-child, 
        .ministries-table >>> table.v-table thead th:first-child, 
        .ministries-table >>> table.v-table tbody th:first-child,
        .ministries-table >>> table.v-table thead th:first-child {
            padding: 0 14px !important;
        }

        .ministries-table >>> th {
            white-space: break-spaces;
        }
    }


</style>
